import { render, staticRenderFns } from "./ProductGroupContextMenu.vue?vue&type=template&id=80ecca60&scoped=true"
import script from "./ProductGroupContextMenu.vue?vue&type=script&lang=ts"
export * from "./ProductGroupContextMenu.vue?vue&type=script&lang=ts"
import style0 from "./ProductGroupContextMenu.vue?vue&type=style&index=0&id=80ecca60&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ecca60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80ecca60')) {
      api.createRecord('80ecca60', component.options)
    } else {
      api.reload('80ecca60', component.options)
    }
    module.hot.accept("./ProductGroupContextMenu.vue?vue&type=template&id=80ecca60&scoped=true", function () {
      api.rerender('80ecca60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product-group/ProductGroupContextMenu.vue"
export default component.exports